<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <section v-else-if="!albumsIsEmpty(isVideo ? 'videoAlbums' : 'albums')" class="albums">
        <div class="section-header section-header-alt album-editable-header albums-breadcrumbs">
            <ul class="container-mobile album-edit-breadcrumbs">
                <li class="album-edit-breadcrumbs-arrow">
                    <router-link :to="{ name: 'profile', params: { id: profileId } }">
                        <!-- {{ albums[0].owner.name }} -->
                        {{ shortenedOwnerName }}
                    </router-link>
                </li>
                <li>
                    <div class="album-edit-breadcrumbs-title">
                        <!-- {{ $t("albums.my") }} -->

                        <span style="margin-left: 4px">
                            {{ isVideo ? $t("albums.video") : $t("albums.photos") }}
                        </span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="section-header section-header-alt">
            <div class="container-mobile">
                <h2 class="heading">
                    <!-- Альбомы <span v-if="isVideo"> видео</span>
          <router-link
            v-if="!userIsEmpty('user') && profileId != user.id"
            :to="{ name: 'profile', params: { id: profileId } }"
            class="link-inherit"
          >
            ({{ albums[0].owner.name }})
          </router-link> -->
                </h2>
                <div @click="showContext = !showContext" ref="contextButton" class="context-opener albums-context-opener"
                    :class="{ 'context-opener-open': showContext }"></div>
                <div v-if="!userIsEmpty('user') && profileId == user.id" class="albums-links">
                    <span @click="$modal.show('create-album', { isVideo: isVideo })" class="link">{{
                        $t("albums.createAlbum")
                    }}</span>
                    <span @click="$modal.show('upload-photos', { isVideo: isVideo })" class="link">
                        {{ $t("albums.add") }}
                        {{ isVideo ? $t("albums.video") : $t("albums.photo") }}
                    </span>
                </div>
                <div v-if="!userIsEmpty('user') && profileId == user.id && showContext" v-click-outside="{
                    exclude: ['contextButton'],
                    handler: 'clickOutsideContext',
                }" class="albums-links-mobile context">
                    <span @click="$modal.show('create-album', { isVideo: isVideo })" class="context-item">{{
                        $t("albums.createAlbum") }}</span>
                    <span @click="$modal.show('upload-photos', { isVideo: isVideo })" class="context-item">{{
                        $t("albums.add") }}
                        {{ isVideo ? $t("albums.video") : $t("albums.photo") }}
                    </span>
                </div>
            </div>
        </div>

        <div class="info-block container-mobile">
            <div class="albums-list">
                <div v-for="(album, index) in albums" v-if="showAll || index < 3" :ref="'element' + index" :key="album.id"
                    class="albums-item">

                    <router-link :to="'/' + $route.meta.type + '/' + profileId + '/' + album.id"
                        class="albums-title albums-title-overflow">
                        {{ album.album_type === 1 ? $t("albums.general") : album.album_type === 2 ? $t("albums.puzzles") :
                            album.title }}
                    </router-link>


                    <div v-if="isVideo" class="albums-photo-count">
                        {{ album.video_count }} {{ $t("albums.video") }}
                    </div>

                    <div v-else class="albums-photo-count">
                        {{ album.photo_count }}
                        <!-- {{ $t("albums.photo") }} -->
                        {{ album.album_type === 1 ? $t("albums.photo") : album.album_type === 2 ?
                            $t("puzzles.puzzle") : '' }}
                    </div>

                    <div class="albums-avatar">
                        <router-link :to="'/' + $route.meta.type + '/' + profileId + '/' + album.id" :style="{
                            'background-image': album.avatar
                                ? 'url(' + album.avatar + ')'
                                : '',
                        }" class="albums-avatar-inner" :class="{
    'no-image': !album.avatar,
    'albums-puzzle': album.album_type == 2,
}"></router-link>
                        <router-link v-if="profileId == user.id"
                            :to="'/' + (isVideo ? 'video-' : '') + 'albums-edit/' + album.id" class="albums-edit">{{
                                $t("albums.edit") }}</router-link>
                    </div>
                </div>
            </div>

            <div class="albums-bottom">
                <span v-if="albumsCount > 3 && !showAll" @click="showAllAlbums" class="link">{{ $t("albums.showAlbums")
                }}</span>
                <div v-if="moreLoader">
                    <button class="button-loader"></button>
                </div>
                <div class="albums-count">
                    {{ albumsCount }}

                    {{
                        declineNouns(albumsCount, [
                            $t("albums.album"),
                            $t("albums.albums"),
                            $t("albums.albumsMore"),
                        ])
                    }}
                    <!-- {{ declineNouns(albumsCount, ["альбом", "альбома", "альбомов"]) }} -->
                </div>
            </div>
        </div>
    </section>
    <section v-else-if="albumsErrors.vip_settings" class="no-auth">
        {{ $t("albums.friendsVips") }}
    </section>
    <section v-else-if="albumsIsEmpty(isVideo ? 'videoAlbums' : 'albums')" class="no-auth">
        {{ $t("albums.listEmpty") }}
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import { declineNouns } from "@/mixins/declineNouns";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
    name: "Albums",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
    },
    mixins: [declineNouns, observeListEnd],
    data() {
        return {
            pageLoader: true,
            profileId: "",
            showAll: false,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
            showContext: false,
            isVideo: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            profileIsEmpty: "profile/isEmpty",
        }),
        shortenedOwnerName() {
            if (this.albums[0].owner.name.length > 12) {
                return "...";
            }
            return this.albums[0].owner.name;
        },
        albums() {
            return this.$store.getters[
                this.getAlbumMethod() + "/fetch" + this.getMethod() + "Albums"
            ];
        },
        albumsIsEmpty() {
            return this.$store.getters[this.getAlbumMethod() + "/isEmpty"];
        },
        albumsErrors() {
            return this.$store.getters[this.getAlbumMethod() + "/errors"];
        },
        albumsCount() {
            return this.$store.getters[
                this.getAlbumMethod() + "/fetch" + this.getMethod() + "AlbumsCount"
            ];
        },
        nextAlbums() {
            return this.$store.getters[
                this.getAlbumMethod() + "/fetch" + this.getMethod() + "NextAlbums"
            ];
        },
    },
    created() {
        this.isVideo = this.$route.meta && this.$route.meta.type == "videos";
        this.profileId = this.$route.params.profileId;
        this.getAlbums();
        let self = this;
        this.observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting === true) {
                    self.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.pageLoader = true;
                this.showAll = false;
                this.moreLoader = false;
                this.profileId = this.$route.params.profileId;
                this.isVideo = this.$route.meta && this.$route.meta.type == "videos";
                this.getAlbums();
            }
        },
    },
    methods: {
        getAlbumMethod(method = "") {
            return (this.isVideo ? "videoAlbums" : "albums") + method;
        },
        getMethod() {
            let str = this.isVideo ? "video" : "photo";
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        getAlbums() {
            this.$store
                .dispatch(this.getAlbumMethod("/get"), this.profileId)
                .then(() => {
                    this.pageLoader = false;
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        updateMoreIndex() {
            this.moreIndex = this.albums.length - 2;
        },
        showAllAlbums() {
            this.showAll = true;
            this.updateMoreIndex();
            this.observeListEnd("element");
        },
        showMore() {
            if (this.nextAlbums) {
                this.moreLoader = true;
                this.$store
                    .dispatch(this.getAlbumMethod("/getNext"))
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        clickOutsideContext() {
            this.showContext = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/components/_votes";
@import "~@/assets/styles/pages/_albums";
@import "~@/assets/styles/pages/_album-edit";
</style>
